import React, {memo, ReactNode} from 'react';
import './index.scss';

type Props = {
    locked: boolean;
    children?: ReactNode;
};

export const Sidebar = memo(function Sidebar({locked, children}: Props) {
    return (
        <div
            className={'device-list-wrapper visible' + (locked ? ' blur' : '')}>
            <div className="device-list">
                {children}
            </div>
        </div>
    );
});
